module.exports = __webpack_public_path__ + "img/circle-messenger1.e6124864.png";